export default (value, limit) => {
  value = value.trim();
  if (value.length <= limit) {
    return value;
  }

  value = value.slice(0, limit);
  return value.trim() + "...";
};
